import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

const UpdatePasswordSchema = yup.object({
  temporary_password: yup
    .string()
    .required(
      t('errors.required', {
        label: t('views.update_password.label.temporary_password'),
      }),
    )
    .label(t('views.update_password.label.temporary_password')),
  new_password: yup
    .string()
    .required(
      t('errors.required', {
        label: t('views.update_password.label.new_password'),
      }),
    )
    .label(t('views.update_password.label.new_password')),
  password_confirmation: yup
    .string()
    .required(
      t('errors.required', {
        label: t('views.update_password.label.password_confirmation'),
      }),
    )
    .oneOf([yup.ref('new_password')], t('views.update_password.schema.error.passwords_must_match')) // Comparação com outro campo
    .label(t('views.update_password.label.password_confirmation')),
})

export default UpdatePasswordSchema
